import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import { STORE_CONSTANTS, THEMES } from '../enums/enums.ts';

interface ITheme {
  theme: string;
  onThemeChange: (theme: string) => void;
}

const ThemeContext = createContext({} as ITheme);

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState<string>(THEMES.LIGHT);

  const handleThemeChange = (selectedTheme: string) => {
    setTheme(selectedTheme);
    localStorage.setItem(STORE_CONSTANTS.THEME, selectedTheme);
  };

  useEffect(() => {
    const savedTheme: string | null = localStorage.getItem(
      STORE_CONSTANTS.THEME
    );

    if (savedTheme) {
      setTheme(savedTheme);
    }
  }, []);

  return (
    <ThemeContext.Provider
      value={{
        theme: theme,
        onThemeChange: handleThemeChange,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
